import React from 'react';
import { PaymentIcon, PaymentType } from 'react-svg-credit-card-payment-icons';
import { Box } from '@planne-software/uni/mui/material';

const DEFAULT_WIDTH = 25;

export type CardBrandArtProps = {
  code: string;
  width?: number;
};

export const CardBrandArt = (props: CardBrandArtProps) => {
  const { code, width = DEFAULT_WIDTH } = props;

  return (
    <Box component='span' sx={{ display: 'inline-flex', alignItems: 'center' }}>
      <PaymentIcon type={code as PaymentType} format='flatRounded' width={width} />
    </Box>
  );
};

export default CardBrandArt;
